import { render, staticRenderFns } from "./BaseBatchAction.vue?vue&type=template&id=c0ec485a"
import script from "./BaseBatchAction.vue?vue&type=script&lang=js"
export * from "./BaseBatchAction.vue?vue&type=script&lang=js"
import style0 from "./BaseBatchAction.vue?vue&type=style&index=0&id=c0ec485a&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports